<sub-header [includeContextHelp]="false" [isModal]="true" [windowHash]=windowHash>
</sub-header>
<p-scrollPanel [style]="{width: '100%', height: '80vh'}" styleClass="custombar1 ">
  <div class="container-fluid">
    <div class="row">
      <div class="col-12 m-t-md" *ngIf="isLoaded()">
        <table class="col-12">
          <tbody>
            <tr *ngFor="let item of templates">
              <td>
                <input (click)="selectTemplate(item)" type="radio" class="i-checks text-center" name="radioSeleccion">
              </td>
              <td>{{item.description}}</td>
            </tr>
          </tbody>
        </table>
        <!--</div>-->
      </div>
    </div>
  </div>
</p-scrollPanel>
